import React, { useMemo } from 'react';
import SVG from 'react-inlinesvg';

import { IMAGES_PATH } from 'constants/images.constants';
import { PaymentType } from 'enums';
import './LogoImage.style.scss';

type Props = {
  bank?: string;
  bankName?: string;
  paymentType?: string;
  paymentTypeName?: string;
  className?: string;
  hideTitle?: boolean;
};

const SPECIAL_LOGOS: Record<string, string> = {
  [PaymentType.SberPay]: 'sberpay-logo.svg',
  [PaymentType.TSBP]: 'tsbp-logo.svg',
};

export const LogoImage: React.FC<Props> = ({
  bank,
  bankName,
  paymentType = '',
  paymentTypeName = '',
  hideTitle,
  ...rest
}) => {
  const logo = useMemo(
    () => SPECIAL_LOGOS[paymentType] || `${bank || paymentType}-logo.svg`,
    [bank, paymentType],
  );

  const title = useMemo(
    () => `${paymentTypeName} ${bankName || ''}`,
    [paymentTypeName, bankName],
  );

  return (
    <SVG src={`${IMAGES_PATH}logos/${logo}`} title={title} {...rest}>
      {!hideTitle && (
        <span
          style={{ maxWidth: '40%' }}
          className="tw-leading-5 tw-text-logo-font tw-font-semibold tw-absolute tw-left-1/4 tw-bottom-6 tw-max-w-card-logo tw-max-h-10 tw-block tw-overflow-hidden	tw-text-ellipsis -tw-translate-x-1/2 tw-translate-y-1/2 md:tw-bottom-8"
        >
          {title}
        </span>
      )}
    </SVG>
  );
};
